import { createLabeledMessages } from '../../../messageUtils';
const confirm = {
    formMessage: 'Are you going to leave with unsaved form ? All date will be lost.',
    formTitle: 'Unsaved form',
    leaveTitle: 'Do you want to leave this site?',
    title: 'Are you sure?',
    continue: 'Continue',
    cancel: 'Cancel',
    doYouWantToLeave: 'Do you really want to leave the page?',
    changesWontBeSaved: "Entered data and changes won't be saved.",
    leaveThePage: 'Opustit stránku',
    stayOnThePage: 'Zůstat na stránce'
};
export default Object.assign({}, confirm, createLabeledMessages(confirm));
